<template>
  <div>
    <vxe-grid
      border
      resizable
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.replenishmentStatus === 'N'
              ? 'primary'
              : row.replenishmentStatus === 'D'
              ? 'danger'
              : row.replenishmentStatus === 'P'
              ? 'warning'
              : row.replenishmentStatus === 'Y'
              ? 'success'
              : row.replenishmentStatus === 'S'
              ? 'logistics'
              : 'info'
          "
        >
          {{ row.v_replenishmentStatus }}
        </el-tag>
      </template>
      <template v-slot:skuSalesChannel="{ row }">
        <el-tag
          v-if="row.v_skuSalesChannel"
          size="mini"
          :type="
            row.skuSalesChannel === 'F'
              ? 'success'
              : row.skuSalesChannel === 'V'
              ? 'warning'
              : ''
          "
        >
          {{ row.v_skuSalesChannel }}
        </el-tag>
      </template>
      <template v-slot:replenishmentDateRange="{ row }">
        <div>{{ `${row.beginDate} - ${row.endDate}` }}</div>
        <div style="color:red" class="mt-1">
          <el-tag size="mini" type="danger" v-if="-1 === row.endDays">
            {{ $l('tag_replenishmentEnd') || '补货计划即将结束' }}
          </el-tag>
          <el-tag
            size="mini"
            type="danger"
            v-if="row.endDays && row.endDays > 0"
          >
            {{ $l('tag_replenishmentEndDays') || `补货计划已结束` }}
            {{ row.endDays }}
            {{ $l('tag_replenishmentEndDay') || `天` }}
          </el-tag>
        </div>
      </template>
      <template v-slot:createInfo="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import tableOpts from './table-opts'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  methods: {
    optCommand({ opt, data }) {
      const { menuType } = opt
      const { amzReplenishmentCode, amzReplenishmentNo } = data
      if (!menuType || !amzReplenishmentCode) return

      switch (menuType) {
        case 'detail':
        case 'audit':
          this.$emit('openEditPage', {
            pageType: menuType,
            params: { code: amzReplenishmentCode },
            query: { amzReplenishmentNo },
          })
          break
        case 'submit':
          this.submit(data)
          break
        default:
          console.error('menuType configuration error: ', menuType)
      }
    },
    submit({ amzReplenishmentCode }) {
      this.$confirm(
        this.$l('tips_submitReply') || '是否要提交返答？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(async () => {
        this.loadingOpen()
        const res = await this.$api
          .ecomAmzReplenishmentSubmitReplyApi({ amzReplenishmentCode })
          .catch(() => null)
        this.loadingClose()
        if (!res) return
        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_Submitted_successfully') || '提交成功!',
          type: 'success',
        })
        this.$emit('reload')
      })
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-tag--logistics {
    background-color: #f9f0ff !important;
    border-color: #d3adf7 !important;
    color: #732ed1 !important;
  }
}
</style>
